export class UnauthorizedError extends Error {
  constructor() {
    super('The session is no longer valid.');
    this.name = 'UnauthorizedError';
  }
}

export class ServerError extends Error {
  constructor() {
    super('The server failed to load the dashboard.');
    this.name = 'ServerError';
  }
}

export class NetworkError extends Error {
  constructor() {
    super('The dashboard could not be reached.');
    this.name = 'NetworkError';
  }
}

export class MealNotFoundError extends Error {
  constructor() {
    super('The meal no longer exists.');
    this.name = 'MealNotFoundError';
  }
}

export class InvalidMealInputError extends Error {
  constructor() {
    super('The meal changes are invalid.');
    this.name = 'InvalidMealInputError';
  }
}

export type DashboardError =
  | UnauthorizedError
  | ServerError
  | NetworkError
  | MealNotFoundError
  | InvalidMealInputError;
